import { Link, Stack, Typography } from '@mui/material';
import { NoDataFound2 } from 'Components';
import { mokedNumber } from 'Config';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

export const NoApplies = () => {
  const generalDictionry = useDictionary(Dictionary, DICTIONARY.General);
  const appliesDictionary = useDictionary(Dictionary, DICTIONARY.Applies);
  const isDesktop = useIsDesktop();

  const redirects = [
    {
      href: process.env.REACT_APP_REDIRECT_URL + 'universalRequest',
      text: generalDictionry.noData.submitNewRequest,
    },
    {
      href: process.env.REACT_APP_REDIRECT_URL + 'compass-rights',
      text: generalDictionry.noData.compassRights,
    },
    {
      href: process.env.REACT_APP_REDIRECT_URL + 'personal-team',
      text: generalDictionry.noData.contact,
    },
  ];

  return (
    <NoDataFound2
      gap={isDesktop ? '48px' : '32px'}
      redirects={redirects}
      headerComponent={
        <Stack gap='16px' alignItems={'center'} padding={'20px'}>
          <Typography variant='h2' color='text.secondary' alignSelf={'center'}>
            {appliesDictionary.yourRequests}
          </Typography>
          <Stack alignItems={'center'} textAlign={'center'}>
            <Typography
              variant='body1'
              color='text.secondary'
              marginRight={'5px'}
            >
              {appliesDictionary.noApplies}
            </Typography>
            <Typography variant={'body3'} color='text.secondary'>
              {appliesDictionary.whenNewApplyDesktop1}
            </Typography>
            <Typography variant={'body3'} color='text.secondary'>
              {appliesDictionary.whenNewApplyDesktop2}{' '}
              {isDesktop ? (
                mokedNumber
              ) : (
                <Link underline='none' href={`tel:${mokedNumber}`}>
                  {mokedNumber}
                </Link>
              )}
            </Typography>
          </Stack>
        </Stack>
      }
    />
  );
};
